import PickerPanel from './picker-panel';

export default PickerPanel;
